import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getFavorites } from '../../Store/favorites/favoritesSlice';
import ProfileNavigation from '../Profile/ProfileNavigation';
import Products from '../Products/Products';
import styles from '../../styles/Favorites.module.scss';

const Favorites = () => {
  const dispatch = useDispatch();
  const { currentUser } = useSelector(({ user }) => user);
  const { list: favorites, isLoading, error } = useSelector(({ favorites }) => favorites);

  useEffect(() => {
    if (currentUser) {
      dispatch(getFavorites());
    }
  }, [dispatch, currentUser]);

  useEffect(() => {
    document.title = 'Обрані товари - Інтернет-магазин';
    return () => {
      document.title = 'Інтернет-магазин';
    };
  }, []);

  if (!currentUser) {
    return (
      <section className={styles.favorites}>
        <div className={styles.empty}>
          <h2>Увійдіть в систему</h2>
          <p>Для перегляду обраних товарів необхідно увійти в систему</p>
          <Link to="/" className={styles.link}>
            Повернутися на головну
          </Link>
        </div>
      </section>
    );
  }

  if (isLoading && favorites.length === 0) {
    return (
      <section className={styles.favorites}>
        <ProfileNavigation />
        <div className={styles.loading}>Завантаження обраних товарів...</div>
      </section>
    );
  }

  return (
    <section className={styles.favorites}>
      <ProfileNavigation />
      <div className={styles.contentWrapper}>
        {error && (
          <div className={styles.error} role="alert">
            {error}
          </div>
        )}
        <div className={styles.header}>
        <h2>Обрані товари</h2>
        <p className={styles.count}>
          Усього товарів: <strong>{favorites.length}</strong>
        </p>
      </div>

      {favorites.length === 0 ? (
        <div className={styles.empty}>
          <h3>Список обраних товарів порожній</h3>
          <p>Додайте товари до обраного, щоб вони відображалися тут</p>
          <Link to="/" className={styles.link}>
            Перейти до каталогу
          </Link>
        </div>
      ) : (
        <div className={styles.productsWrapper}>
          <Products products={favorites} title="" amount={favorites.length} />
        </div>
      )}
      </div>
    </section>
  );
};

export default Favorites;

